import mixpanel from "mixpanel-browser";
// _____________Initialize Mixpanel______________//
mixpanel.init("b5b73c30978032919923185e09888b00", {
  debug: true, // Enables debugging
  track_pageview: true, // Automatically track page views
  persistence: "localStorage", // Stores user data in localStorage
});

// ____________________Regesteration Tracking_______________________//

export const RegisterTracking = (status, msg) => {
  const properties = {
    status: status ? "Success" : "Failure",
    button_name: "Register",
    timestamp: new Date().toISOString(),
  };
  if (!status) properties.failure_reason = msg; // Include only on failure
  mixpanel.track(
    status ? "Register(succeeded)" : "Register(failed)",
    properties
  );
};

export const RegisterDone = (name, email, phone) => {
  mixpanel.identify("-");
  mixpanel.people.set({
    $name: name,
    $email: email,
    $phone: phone,
    "Signup Date": new Date().toISOString(),
  });
};

// ______________________Login Tracking_______________________//

export const LoginTracking = (status, msg) => {
  const properties = {
    status: status ? "Success" : "Failure",
    button_name: "Login",
    timestamp: new Date().toISOString(),
  };
  if (!status) properties.failure_reason = msg;

  mixpanel.track(status ? "Login(succeeded)" : "Login(failed)", properties);
};
// ____________________Reset Password Tracking_______________________//

export const RestPasswordTracking = (status, msg) => {
  const properties = {
    status: status ? "Success" : "Failure",
    button_name: "Reset Password",
    timestamp: new Date().toISOString(),
  };
  if (!status) properties.failure_reason = msg;

  mixpanel.track(
    status ? "Reset Password(succeeded)" : "Reset Password(failed)",
    properties
  );
};

// ______________________Routing Tracking_______________________//
export const RoutingTracking = (user, page) => {
  mixpanel.track(page, {
    status: "n/a", // No Success/Failure concept here
    user: user || "guest",
    page: page,
    timestamp: new Date().toISOString(),
  });
};

export const bookingTracking = ({ user, step, service }) => {
  mixpanel.track(`Booking (${service})`, {
    status: "Success",
    user: user || "guest",
    step,
    timestamp: new Date().toISOString(),
  });
};

export const paymentSelectTracking = ({ user, service, method }) => {
  mixpanel.track("Payment selection", {
    status: "Success",
    user: user || "guest",
    trip: service,
    method,
    timestamp: new Date().toISOString(),
  });
};

export const openVehicleModalTracking = ({ user }) => {
  mixpanel.track("Open vehicle select", {
    user: user || "guest",
  });
};

export const vehicleSelectTracking = ({ user, service, vehicle }) => {
  mixpanel.track("Open vehicle select", {
    user: user || "guest",
    trip: service,
    vehicle,
  });
};

export default mixpanel;
